import { Layer, View } from "@hscmap/stellar-globe";
import { LayerComponentBase } from "@/stellar-globe-components";
import { CreateElement } from "vue";
import { Prop, Component } from "vue-property-decorator";
import { V3 } from "@/utils/math";
import { vec4 } from "gl-matrix";

class GlobeObjectLayer extends Layer {
  constructor(private c: GlobeObject) {
    super()
  }

  render(view: View) {
    const clip = 1
    if (this.c.position) {
      const p = vec4.transformMat4(vec4.create(), [...this.c.position, 1], view.camera.pv as any)
      const x = p[0] / p[3]
      const y = p[1] / p[3]
      const z = p[2] / p[3]
      this.c.visible =
        -clip <= x && x <= clip &&
        -clip <= y && y <= clip &&
        -clip <= z && z <= clip
      if (this.c.visible) {
        const rect = this.globe.canvas.domElement.getBoundingClientRect()
        this.c.left = `${rect.width * (x + 1) / 2.}px`
        this.c.top = `${rect.height * (1 - (y + 1) / 2.)}px`
      }
    }
  }
}

@Component
export class GlobeObject extends LayerComponentBase<GlobeObjectLayer> {
  @Prop({ required: true })
  position!: V3

  visible = false
  top = ''
  left = ''

  render(h: CreateElement) {
    return h('div', {
      style: {
        display: this.visible ? 'block' : 'none',
        position: 'absolute',
        top: this.top,
        left: this.left,
        userSelect: 'none',
      } as CSSStyleDeclaration,
    }, this.$slots.default)
  }

  newLayer() {
    return new GlobeObjectLayer(this)
  }
}
